import { Button } from 'antd';
import Media from 'react-media';
import APP from 'stores/APP';
import classlist from 'utils/classlist';
import { AccountItemProps } from '../../types';
import darkArrowIcon from './images/dark-arrow.png';
import whiteArrowIcon from './images/white-arrow.png';
import './style.scss';

const AccountItem: React.FC<AccountItemProps> = ({
    title,
    isDarkMode,
    statusIcon,
    isLink,
    onClick,
    disabledLink,
    eventParams,
    btnText
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();

            if (eventParams) {
                const { eventModel = '账户设置', eventType, eventName } = eventParams;

                APP.trackEvent(eventModel, eventType, eventName);
            }
        }
    };

    return (
        <Media
            query={{
                maxWidth: 576
            }}>
            {matches => (
                <div
                    className={classlist('account-item-root', {
                        'account-item-dark': isDarkMode
                    })}
                    onClick={isLink && !disabledLink && matches ? handleClick : undefined}>
                    <div className="account-title-container">
                        <span className="account-title">{title}</span>
                    </div>
                    <div className="value-container">
                        {statusIcon || <span />}
                        {isLink &&
                            (matches ? (
                                // link为disabled时不展示箭头icon
                                !disabledLink && (
                                    <img
                                        className="arrow-img"
                                        src={isDarkMode ? darkArrowIcon : whiteArrowIcon}
                                        alt="arrow"
                                    />
                                )
                            ) : (
                                <Button
                                    type="primary"
                                    size="small"
                                    className="link-btn"
                                    onClick={handleClick}
                                    disabled={disabledLink}>
                                    {btnText}
                                </Button>
                            ))}
                    </div>
                </div>
            )}
        </Media>
    );
};

export default AccountItem;
